/**
 * useTheme Hook
 *
 * Access the current theme mode (dark/light) and toggle function.
 *
 * @example
 * const { isDark, toggleTheme, mode } = useTheme();
 *
 * <button onClick={toggleTheme}>
 *   {isDark ? <Sun /> : <Moon />}
 * </button>
 *
 * @see src/context/ThemeContext.tsx for provider
 */

import { useContext } from 'react';
import { ThemeContext, ThemeContextValue } from '@/context/ThemeContext';

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error(
      'useTheme must be used within a ThemeProvider. ' +
      'Make sure your component is wrapped in <ThemeProvider> in main.tsx.'
    );
  }

  return context;
}

export default useTheme;
